import { getCommonWidget } from "../../dashWidgetHelper";
import { PRODUTURO_PIE_COLORS, commonWidgets, getProfuturoAtencion, getProfuturoCustomerJourney, getProfuturoNpsAcumulado, getProfuturoNpsPorMes, getProfuturoSatisfaccion } from "../commonWidgetsProfuturo";

export default {
    title: 'Fuerza de venta registros Dashboard',
    description: 'Fuerza de venta registros Dashboard',
    backgroundClassName: (filters: FiltersUI) => 'epsilon-hero-bg',
    widgets: (filters: FiltersUI) => [
        {
            title: 'Principales Indicadores',
            size: [4, 1],
            type: 'label',
            config: { color: '#B7AADC' },
        },
        getProfuturoNpsAcumulado({
            size: [1, 2],
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_18'
        }),
        getProfuturoNpsPorMes({
            size: [1, 2],
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_18',
        }),
        getProfuturoSatisfaccion({
            size: [1, 2],
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_3',
            helpText: '¿Cuál es tu nivel de satisfacción general con el trámite completo para ser cliente de Profuturo?'
        }),
        getProfuturoAtencion({
            size: [1, 2],
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_9',
            helpText: 'Ahora hablemos de la atención recibida, ¿cómo fue tu experiencia?'
        }),

        getProfuturoCustomerJourney({
            id: 'cj-venta-registros',
            title: 'Customer Journey: Top Two Box',
            size: [4, 2],
            indicators: [
                { name: 'fuerza_ventas_registros_encuesta_pregunta_3', formula: 'count-number', label: 'Satisfacción' }, // csat
                { name: 'fuerza_ventas_registros_encuesta_pregunta_9', formula: 'count-number', label: 'Atención' }, // Atención
                { name: 'fuerza_ventas_registros_encuesta_pregunta_18', formula: 'nps-10', label: 'NPS' }, //nps
            ],
        }),
        {
            title: 'Atributos de experiencia',
            size: [4, 1],
            type: 'label',
            config: { color: '#B7AADC' },
        },
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La sencillez para hacer mi trámite para ser cliente',
            helpText: 'Pensando en tu experiencia con el trámite que hiciste para ser cliente de Profuturo, ¿cuál es tu nivel de satisfacción con cada uno de los siguientes aspectos',
            size: [4, 1],
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_5'
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La duración del trámite para ser cliente (tiempo que transcurrió entre que inició y terminó)',
            size: [4, 1],
            helpText: 'Pensando en tu experiencia con el trámite que hiciste para ser cliente de Profuturo, ¿cuál es tu nivel de satisfacción con cada uno de los siguientes aspectos',
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_6'
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La herramienta utilizada para la captura de huellas y datos durante de trámite',
            size: [4, 1],
            helpText: 'Pensando en tu experiencia con el trámite que hiciste para ser cliente de Profuturo, ¿cuál es tu nivel de satisfacción con cada uno de los siguientes aspectos',
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_7'
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'La asesoría brindada estuvo a la altura de mis expectativas',
            size: [4, 1],
            helpText: 'Pensando en la atención recibida, ¿qué tan de acuerdo te encuentras con cada una de las siguientes afirmaciones?',
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_11'
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'Me mostraron claramente los beneficios de realizar Aportaciones Voluntarias',
            size: [4, 1],
            helpText: 'Pensando en la atención recibida, ¿qué tan de acuerdo te encuentras con cada una de las siguientes afirmaciones?',
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_12'
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'Hubo compromiso y predisposición para responder mis dudas y consultas',
            size: [4, 1],
            helpText: 'Pensando en la atención recibida, ¿qué tan de acuerdo te encuentras con cada una de las siguientes afirmaciones?',
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_13'
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'stackedBar',
            title: 'Me ofrecieron o realizaron un estudio personalizado para el retiro',
            size: [4, 1],
            helpText: 'Pensando en la atención recibida, ¿qué tan de acuerdo te encuentras con cada una de las siguientes afirmaciones?',
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_14'
        }),
        /*{
            title: 'Motivadores y quiebres',
            position: [0, 3],
            size: [4, 1],
            type: 'label',
            config: { color: '#B7AADC' },
        },
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'npsMultipleTrend',
            title: 'Sencillez del trámite para ser cliente',
            position: [0, 4],
            size: [1, 2],
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_5'
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'npsMultipleTrend',
            title: 'Duración del trámite',
            position: [1, 4],
            size: [1, 2],
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_6'
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'npsMultipleTrend',
            title: 'Herramienta para captura de huellas y datos',
            position: [2, 4],
            size: [1, 2],
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_7'
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'npsMultipleTrend',
            title: 'Expectativa de asesoría brindada',
            position: [3, 4],
            size: [1, 2],
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_11'
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'npsMultipleTrend',
            title: 'Claridad de los beneficios de aportaciones voluntarias',
            position: [0, 6],
            size: [1, 2],
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_12'
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'npsMultipleTrend',
            title: 'Compromiso para responder dudas',
            position: [1, 6],
            size: [1, 2],
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_13'
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'npsMultipleTrend',
            title: 'Realización de un estudio personalizado',
            position: [2, 6],
            size: [1, 2],
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_14'
        }),*/
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'wordCount',
            title: 'Comentarios',
            size: [2, 2],
            helpText: 'Por último, ¿qué crees que podríamos mejorar a futuro en el trámite para ser cliente de Profuturo?',
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_19'
        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'pieGenericMedium',
            title: '¿Por qué elegiste a Profuturo?',
            size: [2, 2],
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_20',
            helpText: '¿Por qué elegiste a Profuturo?',
            extraConfigs: {
                colors: PRODUTURO_PIE_COLORS,
            },
            extras: {
                formula: 'count-number'
            }
        }),
        {
            title: 'Análisis de sentimientos',
            size: [4, 1],
            type: 'label'
        },
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'textAnalysis',
            title: 'Análisis de Sentimientos',
            size: [4, 4],
            indicator: 'SENTIMENT'
        }),


        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'wordCount',
            title: 'fuerza_ventas_registros_encuesta_pregunta_22',
            //position: [0, 34],
            size: [2, 2],
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_22',

        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'wordCount',
            title: 'fuerza_ventas_registros_encuesta_pregunta_23',
            //position: [0, 34],
            size: [2, 2],
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_23',

        }),
        getCommonWidget({
            commonWidgets: commonWidgets,
            name: 'wordCount',
            title: 'fuerza_ventas_registros_encuesta_pregunta_19',
            //position: [0, 34],
            size: [2, 2],
            indicator: 'fuerza_ventas_registros_encuesta_pregunta_19',

        }),

    ]
} as DasboardConfig